import axios from '@providers/axiosProvider';
import * as actions from './actions';
import {
  CUSTOM_PROPERTY_TYPE_PROPERTY,
  CUSTOM_PROPERTY_TYPE_CONTRACT,
  CUSTOM_PROPERTY_TYPE_WORK,
  APIGetCustomPropertyLayoutListResponse,
  APIPostCustomPropertyLayoutSettingListRequest,
  APIGetCustomPropertyLayoutSettingListResponse,
} from './types';

/**
 * @summary 機能毎のカスタムプロパティの項目定義リストを取得する
 * @param {typeof CUSTOM_PROPERTY_TYPE_PROPERTY | typeof CUSTOM_PROPERTY_TYPE_CONTRACT typeof CUSTOM_PROPERTY_TYPE_WORK} typeId 建物、契約、案件のいずれかを指定する
 * @returns {Promise<void>}
 */
export const getCustomPropertyLayoutListAsync =
  (
    typeId:
      | typeof CUSTOM_PROPERTY_TYPE_PROPERTY
      | typeof CUSTOM_PROPERTY_TYPE_CONTRACT
      | typeof CUSTOM_PROPERTY_TYPE_WORK,
  ) =>
  async (dispatch: any) => {
    dispatch(actions.setIsLoading(true));

    await axios
      .get<APIGetCustomPropertyLayoutListResponse>(`/custom_property/layout/items`, {
        params: { type_id: typeId },
      })
      .then((response) => {
        dispatch(actions.setCustomPropertyLayoutList(response.data.result.custom_property_list));
      })
      .catch(() => {
        dispatch(actions.setCustomPropertyLayoutList([]));
      });
    dispatch(actions.setIsLoading(false));
  };

/**
 * @summary カスタムプロパティの項目定義情報を全件取得する
 * @returns {Promise<void>}
 */
export const getCustomPropertyLayoutSettingAsync = () => async (dispatch: any) => {
  dispatch(actions.setIsLoading(true));

  await axios
    .get<APIGetCustomPropertyLayoutSettingListResponse>(`/custom_property/layout/`)
    .then((response) => {
      dispatch(actions.setCustomPropertyLayoutSetting([...response.data.result]));
    })
    .catch(() => {
      dispatch(actions.setCustomPropertyLayoutSetting([]));
    });

  dispatch(actions.setIsLoading(false));
};

/**
 * @summary カスタムプロパティの項目定義情報を登録する
 * @param {APIPostCustomPropertyLayoutSettingListRequest} params
 * @returns {Promise<boolean>}
 */
export const postCustomPropertyLayoutSettingAsync =
  (params: APIPostCustomPropertyLayoutSettingListRequest) => async (dispatch: any) => {
    dispatch(actions.setIsSubmitting(true));

    return await axios
      .post(`/custom_property/layout/`, params)
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      })
      .finally(() => {
        dispatch(actions.setIsSubmitting(false));
      });
  };
